import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private defaultTheme: string = "saga-blue";
  private themes = {};

  constructor(@Inject(DOCUMENT) private document: Document) {
      let chk = localStorage.getItem('defaultTheme');

    console.log("Default Theme: " + chk);

      if (chk != null)
      {
        this.defaultTheme = chk;
      }

      console.log("Default theme: " + this.defaultTheme);

      this.themes = [
        {name: "saga-blue", longname: "Saga Blau (Hell)"},
        {name: "saga-green", longname: "Saga Grün (Hell)"},
        {name: "saga-orange", longname: "Saga Orange (Hell)"},
        {name: "saga-purple", longname: "Saga Purple (Hell)"},
  
        {name: "vela-blue", longname: "Vela Blau (Dunkel Blau)"},
        {name: "vela-green", longname: "Vela Grün (Dunkel Blau)"},
        {name: "vela-orange", longname: "Vela Orange (Dunkel Blau)"},
        {name: "vela-purple", longname: "Vela Purple (Dunkel Blau)"},
  
        {name: "arya-blue", longname: "Arya Blau (Dunkel Schwarz)"},
        {name: "arya-green", longname: "Arya Grün (Dunkel Schwarz)"},
        {name: "arya-orange", longname: "Arya Orange (Dunkel Schwarz)"},
        {name: "arya-purple", longname: "Arya Purple (Dunkel Schwarz)"},
      ];

  }

  loadStartupTheme() {
    this.switchTheme(this.defaultTheme);
  }

  switchTheme(theme: string) {
    let themenLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    console.log(themenLink);

    if (themenLink) {
      localStorage.setItem("defaultTheme", theme);
      themenLink.href = theme + ".css";
    }
    console.log(themenLink);
  }

  previewTheme(theme: string)
  {
    let themenLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themenLink) {
      themenLink.href = theme + ".css";
    }
  }
  
  getThemes() : Object
  {
    return this.themes;
  }
  
}
